import { onReady } from '../lib/on-ready.js';

function initDataPushGa() {
    document.querySelectorAll('[data-ga-push]').forEach((element) => {
        element.addEventListener('click', () => {
            ga('send', 'event', 'Cta', 'Click', element.dataset.gaPush);
        });
    });
}

onReady(initDataPushGa);
